import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d7b7752"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog modal-dialog-centered mw-950px" }
const _hoisted_2 = { class: "modal-content px-10 py-10" }
const _hoisted_3 = { class: "fs-1" }
const _hoisted_4 = { class: "row w-100" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "fs-6 fw-semibold mb-2 required" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1))
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "fv-row mb-5" }
const _hoisted_11 = { class: "fs-6 fw-semibold mb-2" }
const _hoisted_12 = { class: "row w-100" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "fv-row mb-5 fv-plugins-icon-container fv-plugins-bootstrap5-row-valid" }
const _hoisted_15 = { class: "fs-6 fw-semibold mb-2 required" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1))
const _hoisted_17 = { class: "col" }
const _hoisted_18 = { class: "fv-row mb-5" }
const _hoisted_19 = { class: "fs-6 fw-semibold mb-2" }
const _hoisted_20 = { class: "col-sm-2" }
const _hoisted_21 = { class: "fv-row mb-5" }
const _hoisted_22 = {
  key: 0,
  class: "fs-6 fw-semibold mb-5"
}
const _hoisted_23 = {
  key: 0,
  class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold mb-8"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_26 = { class: "fv-row mb-5" }
const _hoisted_27 = { class: "fs-6 fw-semibold mb-2 required" }
const _hoisted_28 = { class: "fv-row mb-5 fv-plugins-icon-container" }
const _hoisted_29 = { class: "fs-6 fw-semibold required mb-2" }
const _hoisted_30 = { class: "fv-row mb-5" }
const _hoisted_31 = { class: "fs-6 fw-semibold mb-2 required" }
const _hoisted_32 = { class: "w-100" }
const _hoisted_33 = { class: "text-end" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { key: 0 }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border h-15px w-15px align-middle text-gray-400" }, null, -1))
const _hoisted_38 = { key: 1 }

import { ref, reactive } from "vue";
import { hideModal, showModal } from "@/core/helpers/dom";
import { LanguageTypes } from "@/core/types/LanguageTypes";
import TopicService from "../services/TopicService";
import { type FormRules, FormInstance } from "element-plus";
import { isMobile } from "@/core/config/WindowConfig";
import { ElNotification } from "element-plus";
import "jodit/build/jodit.min.css";
import { JoditEditor } from "jodit-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NoticeDetail',
  emits: ["eventSubmit"],
  setup(__props, { expose: __expose, emit: emits }) {

const noticeDetailShowRef = ref<null | HTMLElement>(null);
const languageOptions = ref([]);
const isAllLanguage = ref(false);
const ruleFormRef = ref<FormInstance>();
const timeFormRef = ref<FormInstance>();
const detail = ref(Array<any>());
const isLoading = ref(true);
const submited = ref(false);

const startDate = ref<any>(new Date());
const startTime = ref<any>(new Date());
const endDate = ref<any>(new Date());
const endTime = ref<any>(new Date());

const formData = ref<any>({
  id: 0,
  title: "",
  language: "",
  content: "",
  author: "",
});

const timeForm = ref<any>({
  id: detail.value["id"],
  startDate: startDate,
  startTime: startTime,
  endDate: endDate,
  endTime: endTime,
});

const timeRules = reactive<FormRules>({
  startDate: [
    {
      required: true,
      message: "Please input effective start date",
      trigger: "blur",
    },
  ],
  startTime: [
    {
      required: true,
      message: "Please input effective start time",
      trigger: "blur",
    },
  ],
  endDate: [
    {
      required: true,
      message: "Please input effective end date",
      trigger: "blur",
    },
  ],
  endTime: [
    {
      required: true,
      message: "Please input effective end time",
      trigger: "blur",
    },
  ],
});

const formRules = reactive<FormRules>({
  title: [
    {
      required: true,
      message: "Please input title",
      trigger: "blur",
    },
  ],
  language: [
    {
      required: true,
      message: "Please select language",
      trigger: "blur",
    },
  ],
  content: [
    {
      required: true,
      message: "Please input content",
      trigger: "blur",
    },
  ],
});

const show = (data) => {
  startDate.value = data.effectiveFrom;
  startTime.value = data.effectiveFrom;
  endDate.value = data.effectiveTo;
  endTime.value = data.effectiveTo;
  detail.value = data;

  let keys = Object.keys(detail.value["contents"]);
  if (keys.length > 0) {
    changeTab(keys[0], detail.value["contents"][keys[0]]);
  } else {
    changeTab("new", null);
  }
  isAllLanguage.value = keys.length >= LanguageTypes.all.length;
  showModal(noticeDetailShowRef.value);
  isLoading.value = false;
};

const tab = ref("new");

const changeTab = (_tab, item) => {
  tab.value = _tab;

  if (item) {
    formData.value = {
      title: item.title,
      content: item.content,
      language: item.language,
      id: item.id,
    };
    languageOptions.value = LanguageTypes.all.filter(
      (langItem) => langItem.code == item.language
    );
  } else {
    formData.value = {
      title: "",
      subtitle: "",
      content: "",
      language: "",
      effectiveTo: "",
      id: 0,
    };
    languageOptions.value = LanguageTypes.all.filter(
      (langItem) => detail.value.contents[langItem.code] == undefined
    );
  }
};


const updateNoticeLanguage = async () => {
  try {
    const res = await TopicService.updateNoticeLanguage(
      detail.value["id"],
      formData.value.id,
      formData.value
    );
    notification(1);
    return res;
  } catch (e) {
    notification(0);
  }
};

const createNoticeLanguage = async () => {
  try {
    const res = await TopicService.createNoticeLanguage(
      detail.value["id"],
      formData.value
    );
    notification(1);
    return res;
  } catch (e) {
    notification(0);
  }
  // const res = await TopicService.createNoticeLanguage(
  //   detail.value["id"],
  //   formData.value
  // );
};
const close = () => {
  hideModal(noticeDetailShowRef.value);
};

const submit = async (formEl: FormInstance | undefined) => {
  submited.value = true;

  try {
    await formEl?.validate(async (valid, fields) => {
      if (valid) {
        if (formData.value.id == 0) {
          const res = await createNoticeLanguage();
          detail.value.contents[formData.value.language] = res;
          isAllLanguage.value =
            Object.keys(detail.value.contents).length >=
            LanguageTypes.all.length;

          changeTab(formData.value.language, res);
        } else {
          const res = await updateNoticeLanguage();
          detail.value.contents[formData.value.language] = res;
        }
        emits("eventSubmit");
      } else {
        console.log("error submit!", fields);
      }
    });
  } catch (e) {
    notification(0);
  }

  submited.value = false;
};
const concatDates = (d1: Date, d2: Date) => {
  if (!d1 || !d2) return "";
  const newDate = new Date(d1);
  const d2_new = new Date(d2);
  newDate.setHours(d2_new.getHours());
  newDate.setMinutes(d2_new.getMinutes());
  newDate.setSeconds(d2_new.getSeconds());

  return newDate;
};

const submitTime = async (formEl: FormInstance | undefined) => {
  try {
    await formEl?.validate(async (valid, fields) => {
      if (valid) {
        const detailForm = {
          type: 2,
          effectiveFrom: concatDates(startDate.value, startTime.value),
          effectiveTo: concatDates(endDate.value, endTime.value),
        };
        await TopicService.updateNoticeTime(detail.value.id, detailForm);
        notification(1);
        emits("eventSubmit");
      } else {
        console.log("error submit!", fields);
      }
    });
  } catch (e) {
    notification(0);
  }
};
const notification = (type: number) => {
  if (type == 1) {
    ElNotification({
      title: "Success",
      message: "Update success!",
      type: "success",
      offset: 100,
    });
  } else {
    ElNotification({
      title: "Error",
      message: "Update failed!",
      type: "error",
      offset: 100,
    });
  }
};
__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    tabindex: "-1",
    "aria-hidden": "true",
    "aria-modal": "true",
    role: "dialog",
    ref_key: "noticeDetailShowRef",
    ref: noticeDetailShowRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(detail.value["title"]), 1),
        _createElementVNode("div", null, [
          _createVNode(_component_el_form, {
            model: timeForm.value,
            rules: timeRules,
            ref_key: "timeFormRef",
            ref: timeFormRef,
            class: "row w-100"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "effectiveFrom",
                class: "col-sm-5"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("title.eventStartDate")), 1),
                        _createVNode(_component_el_form_item, { prop: "startDate" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: startDate.value,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((startDate).value = $event)),
                              type: "date"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _hoisted_8
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("title.eventStartTime")), 1),
                        _createVNode(_component_el_form_item, { prop: "startTime" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_time_picker, {
                              modelValue: startTime.value,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((startTime).value = $event)),
                              "arrow-control": ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                prop: "effectiveTo",
                class: "col-sm-5"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("title.eventEndDate")), 1),
                        _createVNode(_component_el_form_item, { prop: "endDate" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: endDate.value,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((endDate).value = $event)),
                              type: "date",
                              teleported: false,
                              name: "eventName"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _hoisted_16
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("title.eventEndTime")), 1),
                        _createVNode(_component_el_form_item, { prop: "endTime" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_time_picker, {
                              modelValue: endTime.value,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((endTime).value = $event)),
                              teleported: false,
                              "arrow-control": "",
                              prop: "endTime"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  (!_unref(isMobile))
                    ? (_openBlock(), _createElementBlock("label", _hoisted_22, "  "))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "btn btn-primary d-block btn-sm",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (submitTime(timeFormRef.value)), ["prevent"]))
                  }, _toDisplayString(_ctx.$t("title.editTime")), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        (!submited.value)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_23, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value['contents'], (item, key, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "nav-item",
                  key: index
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["nav-link text-active-primary pb-4", { active: tab.value === key.toString() }]),
                    "data-bs-toggle": "tab",
                    onClick: ($event: any) => (changeTab(key, item))
                  }, _toDisplayString(key), 11, _hoisted_24)
                ]))
              }), 128)),
              (!isAllLanguage.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["nav-link text-active-primary pb-4", { active: tab.value === 'new' }]),
                      "data-bs-toggle": "tab",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (changeTab('new', null)))
                    }, _toDisplayString(_ctx.$t("action.new")), 3)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form, {
          class: "demo-ruleForm",
          id: "kt_modal_add_event_form",
          onSubmit: _withModifiers(submit, ["prevent"]),
          model: formData.value,
          rules: formRules,
          ref_key: "ruleFormRef",
          ref: ruleFormRef
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("fields.language")), 1),
              _createVNode(_component_el_form_item, {
                prop: "language",
                name: "language"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: formData.value.language,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.language) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languageOptions.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item['code'],
                          label: item['name'],
                          value: item['code']
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t("title.title")), 1),
              _createVNode(_component_el_form_item, { prop: "title" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.title,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.title) = $event)),
                    type: "text",
                    name: "title"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t("title.content")), 1),
              _createVNode(_component_el_form_item, {
                name: "content",
                prop: "content"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_unref(JoditEditor), {
                      modelValue: formData.value.content,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.content) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("button", {
                class: _normalizeClass(`btn btn-secondary me-3`),
                onClick: _withModifiers(close, ["prevent"])
              }, _toDisplayString(_ctx.$t("action.close")), 9, _hoisted_34),
              _createElementVNode("button", {
                class: _normalizeClass(`btn btn-primary me-3`),
                type: "submit",
                disabled: submited.value || isLoading.value,
                onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (submit(ruleFormRef.value)), ["prevent"]))
              }, [
                (submited.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                      _createTextVNode(_toDisplayString(_ctx.$t("action.waiting")) + " ", 1),
                      _hoisted_37
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.$t("action.submit")), 1))
              ], 8, _hoisted_35)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "model", "rules"])
      ])
    ])
  ], 512))
}
}

})